import React from 'react'
import { ISocialPlatform } from 'interfaces'
import Image from 'next/image'
import { IMAGE_PATHS_V2 } from '../../../shared/consts/imagesPaths'

interface Props {
  social: ISocialPlatform | 'web'
  withColor?: boolean
  size?: number
  onClick?: () => void
  className?: string
}

export const SocialIconButton: React.FC<Props> = ({
  social,
  withColor = true,
  size = 56,
  className,
  onClick,
}) => {
  const src =
    IMAGE_PATHS_V2.icons.socials +
    '/circle' +
    (withColor ? '/fc' : '/nc') +
    '/' +
    social?.toLowerCase() +
    '.svg'

  return (
    <Image
      onClick={onClick}
      src={src}
      alt={social + ' icon'}
      width={size}
      height={size}
      sizes={size * 2 + 'px'}
      className={className}
    />
  )
}
